import { createSelector } from 'selectors'

import { constant } from './dropdownMenu.Constant'

const { selector } = constant

const getTargetSelectors = () => createSelector<NodeListOf<HTMLElement>>({ selector: selector.target }, true)
const getHandleButtonSelector = (scope: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: selector.handleButton })
const getContentSelector = (scope: HTMLElement) => createSelector<HTMLElement>({ scope, selector: selector.content })
const getContentItemSelector = (scope: HTMLElement) =>
	createSelector<NodeListOf<HTMLButtonElement>>({ scope, selector: selector.contentItem }, true)

export const selectors = {
	getTargetSelectors,
	getHandleButtonSelector,
	getContentSelector,
	getContentItemSelector,
}
